import Vue from 'vue'
import Headtop from './Head_top'
Vue.use(Headtop) // 引用自定义组件
Vue.component('Headtop', Headtop) // 初始化组件